var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnergyIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 739.66 702",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#344d5f;stroke-linecap:round;stroke-linejoin:round;stroke-width:34px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17,473.67C65.33,627.21,215.13,713.41,303.44,618.09,353.72,520.59,215.39,409.73,17,473.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.14,512.77c117,34.91,166.29,70.52,270.69,172.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M722.66,381.17C674.33,534.7,524.53,620.9,436.22,525.59c-28.12-54.52-8.68-118.94,58.66-148.92C548,353,635.22,353,722.66,381.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M648.39,408.81c-117,34.91-166.3,70.52-270.7,172.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M501.8,152.49v61.3c0,71.44-58.53,130-130,130h0c-71.45,0-130-58.49-130-130v-61.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 371.81,
    y1: 343.77,
    x2: 371.81,
    y2: 685
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 196.09,
    y1: 141.35,
    x2: 547.54,
    y2: 141.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 309.09,
    y1: 17,
    x2: 309.09,
    y2: 141.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 434.54,
    y1: 17,
    x2: 434.54,
    y2: 141.35
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyIco);
export default __webpack_public_path__ + "static/media/energy-ico.18450488.svg";
export { ForwardRef as ReactComponent };